<template>
  <div>
    <b-row class="mb-0">
      <div class="col">
        <p class="mb-0">
          <strong>DOCUMENTOS GENERALES</strong>
        </p>
      </div>
      <div class="col-sm-4 text-right">
        <button
          class="btn btn-sm btn-success mb-1"
          type="button"
          @click="addDocument()"
          :disabled="!CREATE"
        >
          Nuevo
        </button>
      </div>
    </b-row>

    <!-- <hr class="p-0 mt-0" /> -->

    <section class="proj-page-section comments">
      <section
        class="without"
        v-if="!lstDocuments.length > 0 && !lstDocumentsJury.length > 0 && !lstLetters.length > 0"
        style="margin-top: 0px"
      >
        <div class="row">
          <figure class="text-center">
            <img src="img/sin_adjuntos.png" alt width="210px" />
          </figure>
        </div>
        <div class="row">
          <div class="col-md-12 text-center">
            <h1>Oops!</h1>
            <h4>
              No hay archivos adjuntos
              <br />en este deudor.
            </h4>
          </div>
        </div>
      </section>

      <section v-if="READ && lstDocuments.length > 0">
        <b-table
          :hover="true"
          :striped="true"
          :bordered="false"
          :small="false"
          :fixed="false"
          responsive="sm"
          :items="lstDocuments"
          :fields="fields_file"
        >
          <template slot="stage" slot-scope="data">{{
            data.item.stage == "P" ? "Prejuridico" : "Jurídico"
          }}</template>

          <template slot="actions" slot-scope="data">
            <!-- <template v-slot:cell(actions)="data"> -->
            <b-button
              size="sm"
              class="mr-1"
              variant="primary"
              @click="viewDocument(data.item)"
              v-if="READ"
              title="Ver"
            >
              <i class="fa fa-eye"></i>
            </b-button>

            <b-button
              size="sm"
              variant="warning"
              class="mr-1"
              title="Descargar"
              @click="dowloadDocument(data.item)"
              v-if="DOWLOAD"
            >
              <i class="fa fa-download"></i>
            </b-button>

            <b-button
              size="sm"
              variant="danger"
              @click="deleteDocument(data.item)"
              title="Eliminar"
              v-if="DELETE"
            >
              <i class="fa fa-trash"></i>
            </b-button>
          </template>
        </b-table>
      </section>

      <b-row class="mb-2 mt-5" v-if="READ && lstLetters.length > 0">
        <div class="col">
          <p class="mb-0">
            <strong>CARTAS</strong>
          </p>
        </div>
      </b-row>

      <section v-if="READ && lstLetters.length > 0">
        <b-table
          :hover="true"
          :striped="true"
          :bordered="false"
          :small="false"
          :fixed="false"
          responsive="sm"
          :items="lstLetters"
          :fields="fields_letters"
        >
          <template slot="actions" slot-scope="data">
            <!-- <template v-slot:cell(actions)="data"> -->
            <b-button
              size="sm"
              variant="warning"
              class="mr-1 pointer"
              title="Descargar"
              @click="getLetterPDF(data.item.type)"
              v-if="DOWLOAD"
            >
              <i class="fa fa-download"></i>
            </b-button>
          </template>
        </b-table>
      </section>


      <b-row class="mb-2 mt-5" v-if="READ && lstDocumentsJury.length > 0 && role_id != 6">
        <div class="col">
          <p class="mb-0">
            <strong>DOCUMENTOS JURIDICOS</strong>
          </p>
        </div>
      </b-row>

      <section v-if="READ && lstDocumentsJury.length > 0 && role_id != 6">
        <b-table
          :hover="true"
          :striped="true"
          :bordered="false"
          :small="false"
          :fixed="false"
          responsive="sm"
          :items="lstDocumentsJury"
          :fields="fields_jury"
        >
          <template slot="actions" slot-scope="data">
            <!-- <template v-slot:cell(actions)="data"> -->
            <b-button
              size="sm"
              variant="warning"
              class="mr-1"
              title="Descargar"
              @click="dowloadDocument(data.item)"
              v-if="DOWLOAD"
            >
              <i class="fa fa-download"></i>
            </b-button>

            <b-button
              size="sm"
              variant="danger"
              @click="deleteDocument(data.item)"
              title="Eliminar"
              v-if="DELETE"
            >
              <i class="fa fa-trash"></i>
            </b-button>
          </template>
        </b-table>
      </section>

    </section>

    <!-- MODAL PARA LOS CREAR Y EDITAR -->
    <div class="modal fade" id="dlgDocument">
      <div class="modal-dialog modal-dialog-centered modal-success">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header m-0 p-2">
            <h6 class="modal-title">DOCUMENTO</h6>
            <button type="button" class="close" @click="closeDocument()">
              &times;
            </button>
          </div>
          <!-- Modal body -->
          <div class="modal-body">
            <form
              @submit.prevent="saveDocument()"
              method="post"
              v-if="document.table_id"
            >
              <b-row>
                <b-col cols="11" sm="11" class="center-block">
                  <b-row>
                    <b-col sm="12" v-if="errores.length">
                      <b-alert show variant="danger">
                        <b>Por favor corrige los siguientes errores:</b>
                        <ul>
                          <li v-for="(error, index) in errores" :key="index">
                            {{ error }}
                          </li>
                        </ul>
                      </b-alert>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col sm="6">
                      <b-form-group>
                        <label for="cmbStage">Etapa</label>
                        <b-form-select
                          v-model="document.stage"
                          id="cmbStage"
                          :disabled="disabledDocument"
                        >
                          <template slot="first">
                            <option :value="null" disabled>
                              -- Seleccione --
                            </option>
                          </template>

                          <option value="P">Prejuridico</option>
                          <option value="J">Jurídico</option>
                        </b-form-select>
                      </b-form-group>
                    </b-col>

                    <b-col sm="6">
                      <b-form-group>
                        <label for="txtFecha">Fecha</label>
                        <b-form-input
                          type="date"
                          id="txtFecha"
                          v-model="document.document_date"
                          :disabled="disabledDocument"
                          :max="maxDate"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col sm="12">
                      <b-form-group>
                        <label for="txtConcepto">Concepto</label>
                        <b-form-input
                          type="text"
                          id="txtConcepto"
                          v-model="document.concept"
                          :disabled="disabledDocument"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col sm="12">
                      <label>Documento</label>
                      <b-form-file
                        :browse-text="'Buscar'"
                        v-model="file"
                        :state="Boolean(file)"
                        v-on:change="onImageChange"
                        placeholder="Elija un archivo o suéltelo aquí ..."
                        drop-placeholder="Suelta el archivo aquí ..."
                        :disabled="disabledDocument"
                      ></b-form-file>
                    </b-col>
                  </b-row>

                  <b-row v-if="!disabledDocument" class="mt-3">
                    <b-col sm="6" class="center-block">
                      <b-row>
                        <b-col sm="6">
                          <b-button
                            type="submit"
                            variant="success"
                            class="btn-sm col-sm-12"
                            :disabled="disabledDocument"
                            >CREAR</b-button
                          >
                        </b-col>

                        <b-col sm="6">
                          <b-button
                            type="button"
                            variant="danger"
                            class="btn-sm col-sm-12"
                            @click="closeDocument()"
                            >CANCELAR</b-button
                          >
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- FIN MODAL PARA LOS CREAR Y EDITAR -->
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "document",
  props: {
    _table: {
      type: String,
      default: null
    },
    _table_id: {
      type: String,
      default: true
    },
    _settlement: {
      type: Object,
      default: {}
    }
  },
  //props: ["_table", "_table_id"],

  data: () => {
    return {
      token: localStorage.getItem("token"),
      isAdmin: localStorage.getItem("auth_is_admin") === "S" ? true : false,
      role_id: localStorage.getItem("role_id"), // PARA DETERMINAR EL ROL DEL USUARIO QUE INGRESA
      maxDate: moment(String(new Date())).format("YYYY-MM-DD"),
      table: null,
      table_id: null,
      lstDocuments: [],
      lstDocumentsJury: [],
      lstLetters: [],
      pagination: {},
      isEdit: false,
      disabled: false,
      datos: [],
      errores: [],
      isEditDocument: false,
      disabledDocument: false,
      document: {
        table: null,
        table_id: null,
        stage: null,
        document_date: null,
        concept: null,
      },
      file: null,
      // CABECERAS PARA LA TABLA DE LOS DOCUMENTOS
      fields_file: [
        {
          key: "selected",
          sortable: false,
          label: "",
          class: "options-column",
        },

        { key: "concept", label: "Concepto" },
        { key: "document_date", label: "Fecha" },
        { key: "stage", label: "Etapa" },

        // { key: "name", label: "Nombre" },
        { key: "created_at", label: "Fecha de importación" },
        { key: "actions", label: "Opciones" },
      ],

      fields_jury: [
        {
          key: "selected",
          sortable: false,
          label: "",
          class: "options-column",
        },

        { key: "name", label: "Nombre" },
        { key: "created_at", label: "Fecha" },
        { key: "city_name", label: "Ciudad" },
        { key: "number_filed", label: "Radicado" },
        { key: "judged_name", label: "Juzgado" },

        { key: "status_name", label: "Estado demanda" },
        { key: "demand_type_name", label: "Tp. demanda" },
        { key: "user_name", label: "Creado por" },

        { key: "actions", label: "Opciones" },
      ],

      fields_letters: [

        { key: "created_at", label: "Fecha envio" },
        { key: "letter", label: "Tipo" },
        { key: "status_name", label: "Estado" },
        { key: "user_name", label: "Creado por" },

        { key: "actions", label: "Opciones" },
      ],
      // VARIABLES PARA LA GESTÓN DE LAS ACCIONES Y PERMISOS DE CADA USUARIO
      CREATE: false,
      READ: false,
      UPDATE: false,
      DELETE: false,
      DOWLOAD: false,
    };
  },
  beforeMount() {
    this.table = this._table === undefined ? null : this._table;
    this.table_id = this._table_id === undefined ? null : this._table_id;
    this.enabledActions();
    this.getDocuments();
  },

  methods: {
    getDocuments() {
      showLoader();
      //console.log('getDocuments')

      // LISTADO DE DOCUMENTOS DEL CLIENTE O CUENTA
      let data = {
        table: this.table,
        table_id: this.$route.params.id,
        process_id: null,
      };

      this.lstDocuments = [];

      this.$http
        .post(
          `${this.$urlApi}documents/get?token=${this.token}`, JSON.stringify(data),
          { headers: { "Content-Type": "application/json" } }
        )
        .then(
          function (response) {
            // console.log(response);

            let lstDocumentAux = response.data.data;

            for (var i = 0; i < lstDocumentAux.length; i++) {
              var item = lstDocumentAux[i];
              var data_aux = null;
              if (item.data) {
                data_aux = JSON.parse(item.data);
              }

              let document = {
                id: item.id,
                created_at: item.created_at,
                data: item.data,
                name: item.name,
                path: item.path,
                concept:
                  data_aux === null
                    ? null
                    : data_aux.concept === null
                    ? null
                    : data_aux.concept,
                stage:
                  data_aux === null
                    ? null
                    : data_aux.stage === null
                    ? null
                    : data_aux.stage,
                document_date:
                  data_aux === null
                    ? null
                    : data_aux.document_date === null
                    ? null
                    : data_aux.document_date,
                table: item.table,
                table_id: item.table_id,
                type: item.type,
                updated_at: item.updated_at,
              };

              this.lstDocuments.push(document);
            }
            hideLoader();
          },
          (error) => {
            console.log(error);
            hideLoader();
          }
        );

        this.getDocumentsLegal();
        this.getLetters();
    },

    getDocumentsLegal() {
      showLoader();
      //console.log('getDocuments')

      // LISTADO DE DOCUMENTOS DEL CLIENTE O CUENTA
      let data = {
        table: this.table,
        table_id: this.$route.params.id,
        process_id: 2, // JURIDICO
      };

      this.lstDocumentsJury = [];

      this.$http
        .post(
          `${this.$urlApi}documents/get?token=${this.token}`,
          JSON.stringify(data),
          { headers: { "Content-Type": "application/json" } }
        )
        .then(
          function (response) {
            console.log(
              "lstDocumentsJury ------------------------------------------>",
              response
            );

            if(response && response.data && response.data.data) {

              let lstDocumentAux = response.data.data;

              for (var i = 0; i < lstDocumentAux.length; i++) {
                var item = lstDocumentAux[i];
                var data_aux = null;
                if (item.data) {
                  data_aux = JSON.parse(item.data);
                }

                let document = {
                  id: item.id,
                  created_at: item.created_at,
                  data: item.data,
                  name: item.name,
                  path: item.path,
                  status_name:
                    data_aux === null
                      ? null
                      : data_aux.status_name === null
                      ? null
                      : data_aux.status_name,
                  number_filed:
                    data_aux === null
                      ? null
                      : data_aux.number_filed === null
                      ? null
                      : data_aux.number_filed,
                  city_name:
                    data_aux === null
                      ? null
                      : data_aux.city_name === null
                      ? null
                      : data_aux.city_name,
                  judged_name:
                    data_aux === null
                      ? null
                      : data_aux.judged_name === null
                      ? null
                      : data_aux.judged_name,

                  demand_type_name:
                    data_aux === null
                      ? null
                      : data_aux.demand_type_name === null
                      ? null
                      : data_aux.demand_type_name,

                  user_name:
                    data_aux === null
                      ? null
                      : data_aux.user_name === null
                      ? null
                      : data_aux.user_name,

                  table: item.table,
                  table_id: item.table_id,
                  type: item.type,
                  updated_at: item.updated_at,
                };

                this.lstDocumentsJury.push(document);
              }
            }
            hideLoader();
          },
          (error) => {
            console.log(error);
            hideLoader();
          }
        );
    },
    getLetters() {
      showLoader();

      this.$http
        .get(
          `${this.$urlApi}letters/debtor/${this.$route.params.id}?token=${this.token}`,
          { headers: { "Content-Type": "application/json" } }
        )
        .then(
          function (response) {
            console.log("lstLetters ::::::::", response);
            this.lstLetters = response.data.data;
            hideLoader();
          },
          (error) => {
            console.log(error);
            hideLoader();
          }
        );
    },
    getRowCount(items) {
      return items.length;
    },
    getBadge(status) {
      return getBadge(status);
    },
    getTextStatus(status) {
      return getTextStatus(status);
    },
    formatDate(value) {
      return moment(String(value)).format("DD/MM/YYYY");
    },
    initParametersInvoice() {
      this.document.stage = null;
      this.document.document_date = null;
      this.document.concept = null;
      this.document.table_id = this.table_id;
      this.document.table = this.table;
    },
    addDocument() {
      this.initParametersInvoice();
      this.errores = [];
      $("#dlgDocument").modal({ backdrop: "static", keyboard: false }); // EVITA QUE SE CIERRE EL MODAL AL DAR CLIC FUERA DE EL
      this.isEditDocument = false;
      $("#dlgDocument").modal("show");
    },
    editDocument(item) {
      if (!this.isAdmin) {
        // VERIFICAR EL TIEMPO TRANSCURRIDO
        var fechaGestion = moment(item.created_at, "YYYY-MM-DD HH:mm:ss");
        var fechaActual = moment(new Date(), "YYYY-MM-DD HH:mm:ss");
        var minutos = fechaActual.diff(fechaGestion, "m");

        if (minutos > 10) {
          this.$swal({
            title: "Oops...",
            text:
              "El documento ya superó los 10 minutos para ser modificado, contacte con el administrador.",
            type: "error",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          });
          return false;
        }
      }

      // this.initParametersInvoice();
      this.errores = [];
      $("#dlgDocument").modal({ backdrop: "static", keyboard: false }); // EVITA QUE SE CIERRE EL MODAL AL DAR CLIC FUERA DE EL
      this.document = item;
      this.file = null;
      this.isEditDocument = true;
      $("#dlgDocument").modal("show");
    },
    viewDocument(item) {
      // console.log(item);
      // this.initParametersInvoice();
      $("#dlgDocument").modal({ backdrop: "static", keyboard: false }); // EVITA QUE SE CIERRE EL MODAL AL DAR CLIC FUERA DE EL
      this.document = item;
      this.disabledDocument = true;
      $("#dlgDocument").modal("show");
    },
    saveDocument() {
      if (this.isEditDocument) {
        this.updateDocument();
      } else {
        this.$swal({
          title: "Guardar",
          text: "¿Está seguro que toda la información ingresada es correcta?",
          type: "question",
          showCancelButton: true,
          cancelButtonText: "Volver",
          confirmButtonText: "Si",
        }).then((result) => {
          if (result.value) {
            this.createDocument();
          }
        });
      }
    },
    createDocument() {
      showLoader();

      let auth = localStorage.getItem("auth");
      auth = JSON.parse(auth);
      this.document.url = `${location.origin}/#/customers/view/`;
      this.document.user_id = auth[0].id;
      this.document.auth_is_admin = this.isAdmin;
      // this.datos = JSON.stringify(this.document);
      let formData = new FormData();
      formData.append("data", JSON.stringify(this.document));
      formData.append("document", this.file);
      // console.log(this.document);
      // return false;

      this.$http
        .post(
          `${this.$urlApi}documents/store/debtor?token=${this.token}`,
          formData,
          {
            headers: { "Content-Type": undefined },
          }
        )
        .then(function (response) {
          hideLoader();

          this.$swal({
            title: "Buen trabajo",
            text: "Documento guardado correctamente!",
            type: "success",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          }).then((result) => {
            if (result.value) {
              // CERRAR EL MODAL Y LISTAR
              this.document.table_id = null;
              this.getDocuments();
              $("#dlgDocument").modal("hide");
            }
          });
        })
        .catch((error) => {
          console.log(error);
          this.errores = getMsgError(error);
          hideLoader();
        });
    },
    updateDocument() {
      // COMO ES UN OBJETO FormData SE DEBE ENVIAR UN POST Y CAMBIAR EL METODO A PUT, SOLO SIRVE PARA LARAVEL
      showLoader();
      let auth = localStorage.getItem("auth");
      auth = JSON.parse(auth);
      this.document.url = `${location.origin}/#/customers/view/`;
      this.document.user_id = auth[0].id;
      this.document.auth_is_admin = this.isAdmin;
      // this.datos = JSON.stringify(this.document);
      let formData = new FormData();
      formData.append("data", JSON.stringify(this.document));
      formData.append("document", this.file);
      formData.append("_method", "PUT");
      // console.log(this.document);
      // return false;

      this.$http
        .post(
          `${this.$urlApi}documents/update/debtor?token=${this.token}`,
          formData,
          {
            headers: { "Content-Type": undefined },
          }
        )
        .then(function (response) {
          console.log(response);
          hideLoader();

          this.$swal({
            title: "Buen trabajo",
            text: "Documento guardado correctamente!",
            type: "success",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          }).then((result) => {
            if (result.value) {
              // CERRAR EL MODAL Y LISTAR
              this.document.table_id = null;
              this.getDocuments();
              $("#dlgDocument").modal("hide");
            }
          });
        })
        .catch((error) => {
          console.log(error);
          this.errores = getMsgError(error);
          hideLoader();
        });
    },
    deleteDocument(item) {
      if (!this.isAdmin) {
        // VERIFICAR EL TIEMPO TRANSCURRIDO
        var fechaGestion = moment(item.created_at, "YYYY-MM-DD HH:mm:ss");
        var fechaActual = moment(new Date(), "YYYY-MM-DD HH:mm:ss");
        var minutos = fechaActual.diff(fechaGestion, "m");

        if (minutos > 10) {
          this.$swal({
            title: "Oops...",
            text:
              "El documento ya superó los 10 minutos para ser eliminado, contacte con el administrador.",
            type: "error",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          });
          return false;
        }
      }

      this.$swal({
        title: "Eliminar",
        text: "Desea eliminar el documento ?",
        type: "question",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        confirmButtonText: "Aceptar",
      }).then((result) => {
        if (result.value) {
          showLoader();
          this.$http
            .delete(`${this.$urlApi}documents/${item.id}?token=${this.token}`, {
              headers: { "Content-Type": "application/json" },
            })
            .then(function (response) {
              //console.log(response)
              hideLoader();

              this.$swal({
                title: "Buen trabajo",
                text: "Documento eliminado correctamente!",
                type: "success",
                showCancelButton: false,
                confirmButtonText: "Aceptar",
              }).then((result) => {
                if (result.value) {
                  this.getDocuments();
                }
              });
            })
            .catch((error) => {
              console.log(error.body.error);
              hideLoader();
            });
        }
      });
    },
    closeDocument() {
      this.isEditDocument = false;
      this.disabledDocument = false;
      $("#dlgDocument").modal("hide");
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    onImageChange(e) {
      console.log(e.target.files[0]);
      this.file = e.target.files[0];
    },
    dowloadDocument(doc) {
      window.open(`${this.$urlApi}file/${doc.name}?token=${this.token}`);
    },
    enabledActions() {
      var auth = localStorage.getItem("auth");
      auth = JSON.parse(auth)[0];
      this.CREATE = auth.create == 1;
      this.READ = auth.read == 1;
      this.UPDATE = auth.update == 1;
      this.DELETE = auth.delete == 1;
      this.DOWLOAD = this.READ; // DESCARGAR EL DOCUMENTO

      // switch (this.role_id) {
      //   case "1": // ADIMISTRADOR
      //     this.CREATE = true;
      //     this.READ = true;
      //     this.UPDATE = true;
      //     this.DELETE = true;
      //     this.DOWLOAD = true;
      //     break;

      //   case "2": // COMERCIAL
      //     this.CREATE = true;
      //     this.READ = true;
      //     this.UPDATE = false;
      //     this.DELETE = false;
      //     this.DOWLOAD = true;
      //     break;

      //   case "4": // PREJURIDICO
      //     this.CREATE = true;
      //     this.READ = true;
      //     this.UPDATE = true;
      //     this.DELETE = true;
      //     this.DOWLOAD = true;
      //     break;

      //   case "6": // PREJURIDICO
      //     this.CREATE = true;
      //     this.READ = true;
      //     this.UPDATE = false;
      //     this.DELETE = false;
      //     this.DOWLOAD = true;
      //     break;

      //   default:
      //     // OTRO ROL
      //     this.CREATE = false;
      //     this.READ = false;
      //     this.UPDATE = false;
      //     this.DELETE = false;
      //     this.DOWLOAD = false;
      //     break;
      // }
    },

    getLetterPDF(type) 
    {
    showLoader();

    let info = JSON.stringify(
      {
        type: type,
        debtor_id: this.$route.params.id,
        ineteres: (this._settlement.capital - this._settlement.initial_payments),
        fees: this._settlement.fee
      });

    this.$http
      .post(
        `${this.$urlApi}report/letter/debtor?token=${this.token}`,
        info,
        {
          headers: { "Content-Type": "application/json" },
          responseType: "blob"
        }
      )
      .then(
        function(response) {
          console.log(response);
          _downloadFile(response, "letter-" + type + "-" + this.$route.params.id);
          hideLoader();
        },
        error => {
          console.log(error);
          hideLoader();
        }
      );
    }

  },
};
</script>
